import React,{Component,Fragment} from 'react'
import styles from './index.module.scss'
import { observer,inject } from 'mobx-react'
import ChangeInfo from '../../components/ChangeInfo'
import SDK from '../../sdk/utils'
import environment from '../../lib/env.js'
import wxPay from '../../lib/weixinPay.js'
import { cibaWxEduLogin } from '../../lib/wxLogin.js'
import Cookie from 'js-cookie'
import api from '../../api/request.js'
import isIPhoneX from '../../lib/isIPhoneX'
@inject('tabBar')
@inject('userInfo')
@inject('weChat')
@observer
class Pagesale extends Component {
    constructor(props) {
        super(props)
        this.state = {
            readArgument:false,
            phoneType:null,
            hasPop:false,
            isIpad:/ipad/i.test(navigator.userAgent.toLowerCase()) || /macintosh/.test(navigator.userAgent.toLowerCase()),
            infoShow:false,
            infoWord:'购买成功',
            day:0,
            hour:0,
            min:0,
            sec:0,
        }
        this.differBottom = this.differBottom.bind(this);
        this.handleJump = this.handleJump.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClickPay = this.handleClickPay.bind(this);
        this.confirm = this.confirm.bind(this);
        this.countdown = this.countdown.bind(this);
        this.infoComponent = this.infoComponent.bind(this);
    }
    // 获取props属性
    get getPhoneType () {
        return this.props.userInfo.phoneType
    }
    // 支付结果弹窗提示
    infoComponent() {
        if(this.state.infoShow) {
            return (
                <div className={styles.infoBlock}>
                    <div className={styles.content}>
                        <div className={styles.successIcon}>
                            <img src={require('./images/paySuccess.jpg')}/>
                        </div>
                        <div className={styles.word}>
                            {this.state.infoWord}
                        </div>
                        <div onClick={this.confirm} className={styles.button}>
                            确定
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <></>
            )
        }
    }
    confirm() {
        this.setState(() => ({infoShow:false}))
    }
    // ios android 续费协议区分
    differBottom() {
        let result;
        if(this.state.phoneType === 'ios') {
            result = <div className={`${styles.blockArea} ${styles.declare}`}>
                        <div className={styles.title}>金山词霸会员自动续费商品声明：</div>
                        <div className={styles.wordItems}>
                            <span>1· </span>
                            <span>付款：会员产品您确定购买后，会从您的苹果iTunes 账户扣费；</span>
                        </div>
                        <div className={styles.wordItems}>
                            <span>2· </span>
                            <span>续费会员：您的会员到期前24小时，苹果会自动为您从iTunes账户扣费，成功后有效期自动延长一个周期；</span>
                        </div>
                        <div className={styles.wordItems}>
                            <span>3· </span>
                            <span>取消续费：若需要取消自动续费，请到期前至少24小时在“iOS-账户设置”关闭关闭后不再扣费；</span>
                        </div>
                    </div>
        } else {
            result = <div className={`${styles.blockArea} ${styles.declare}`}>
                        <div className={styles.title}>金山词霸会员自动续费商品声明：</div>
                        <div className={styles.wordItems}>
                            <span>1· </span>
                            <span>续费：您的会员到期前24小时，会为您自动续费，成功后有效期自动延长一个周期；</span>
                        </div>
                        <div className={styles.wordItems}>
                            <span>2· </span>
                            <span>取消续费：续费可以随时取消，若需要取消自动续费，请到期前至少24小时在“微信-我-钱包-支付管理-自动扣费”进行，取消后不再续费。</span>
                        </div>
                    </div>
        }
        return result;
    }
    // 是否有运营活动判断 优惠规则 活动仅针对android用户
    isInActivity() {
        return this.state.phoneType !== 'ios' && this.props.userInfo.vipInfo.year[1].activity_flag == 1
    }
    handleChange(e) {
        e.target.checked ? this.setState(() =>({readArgument:true})) : this.setState(() => ({readArgument:false}))
    }
    handleJump (val) {
        // let path;
        // val === 'member' ? path = '/protocol-vip' : path = '/protocol-auto'
        // this.props.tabBar.changeHistory('/superMember')
        // this.props.history.push({
        //     pathname:path,
        // })
        if(environment.environment === 'wx') {
            val === 'member' ? window.location.href = 'https://my.iciba.com/vip/vip2/#/protocol-vip' : window.location.href = 'https://cdn.iciba.com/www/terms/iciba/mobile/privacy.html'
        }
        let href;
        val === 'member' ? href = 'https://my.iciba.com/vip/vip2/#/protocol-vip' : href = 'https://cdn.iciba.com/www/terms/iciba/mobile/privacy.html';
        SDK.toPage(
            `{"vc":"KSNormalWebViewController","urlString":"${href}","_statistic_flag":"vip-buy"}`,
            `{activity:com.kingsoft.MessageDetailActivity,url:'${href}'}`
        )
    }
    // 微信公众号支付
    wxhandlePay(priceInfo) {
        // 微信判定登录
        if(!Cookie.get('Authorization') || !Cookie.get('WPS_COURSE_openid')) {
            cibaWxEduLogin()
        }
        let params = {
            goodId : '005000060000008',
            totalFee : priceInfo.data.year[1].activity_price,
            channel : 'wxpay_jsapi',
            client : '6',
            source : 'wpa_push_0',
            openid : Cookie.get('WPS_COURSE_openid'),
        }
        // console.log(params)
        api.payModule.goPay({params,needSignature:true}).then(res => {
            wxPay(res.data.jsApiParameters)
            // 查询支付订单状态
            window.queryOrder = setInterval(() => {
                let params = {tradeNo:res.data.tradeNo}
                api.payModule.queryPaystate({params,needSignature:true}).then(res => {
                    console.log(res)
                    if(res.data == 1 && res.msg === 'success') {
                        this.setState(() => ({infoShow:true}))
                        clearInterval(window.queryOrder)
                    }
                })
                .catch(error => {
                    this.setState(() => ({infoShow:true}))
                    this.setState(() => ({infoWord:'购买失败'}))
                    clearInterval(window.queryOrder)
                })
            },3000)
        })
        .catch(error => {
        })
    }
    countdown(end) {
        let now_time = Date.parse(new Date());
        let remaining = end - now_time;
        // 倒计时
        this.timer = setInterval(() => {
             //防止出现负数
        if (remaining > 1000) {
             remaining -= 1000;
             let day = Math.floor((remaining / 1000 / 3600) / 24);
             let hour = Math.floor((remaining / 1000 / 3600) % 24);
             let minute = Math.floor((remaining / 1000 / 60) % 60);
             let second = Math.floor(remaining / 1000 % 60);
             this.setState({
                day:day,
                hour:hour < 10 ? "0" + hour : hour,
                min:minute < 10 ? "0" + minute : minute,
                sec:second < 10 ? "0" + second : second
            })
        } else {
            clearInterval(this.timer);
        }
        },1000)
    }
    handleClickPay () {
        // 埋点
        if(window.dw) window.dw.onEvent('activity_anniversary_click')
        // 微信公众号
        if(environment.environment === 'wx') {
            api.payModule.queryPrice({
                baseURL:'//goods.iciba.com',
                params:{c:'vip',m:'vip_list_new'}
            }).then(res => {
                this.wxhandlePay(res);
            })
            return false;
        }
        // 没登陆的朋友，先去登陆吧
        // if(!this.props.userInfo.isLogin && this.state.phoneType !== 'ios') {
        if(!this.props.userInfo.isLogin) {
            SDK.autoLogin().then(res => {
                this.props.userInfo.refreshLoginState()
            })
            return false;
        }
        // 校验通过 支付
        else {
            const click_flag = this.props.userInfo.vipInfo.year[1].click_flag;
            let click_type;
            if(click_flag == 'buy') {
                click_type = 'super_buy';
            } else if (click_flag == 'continue') {
                click_type = 'super_renew'
            } else {
                click_type = 'common_pro'
            }
            let payData;
            // ios走的appStore支付 android走的页面支付 参数有区别
            // ios
            if(this.state.phoneType === 'ios') {
                if(this.props.userInfo.vipInfo.is_duration ==  1) {
                    this.props.tabBar.changeTabShow(true);
                    this.props.tabBar.changeContant('请先取消月会员自动续费，再购买年会员')
                    return false;
                }
                // const iosInfo = this.props.userInfo.vipInfo.year_product_ids[1];
                const iosInfo = this.props.userInfo.vipInfo.year[1];
                // toBuy(iosInfo.goodId, iosInfo.good_type, this.total_price,subjectName,'',(res)=>{
                //     this.getClass()
                //   })
                payData = {
                    book_id: iosInfo.goodId,
                    pay_good_id: iosInfo.goodId,
                    p_name:iosInfo.vip_name,
                    p_price:  iosInfo.activity_price,
                    pay_type: 1,
                    type:'',
                    good_type: iosInfo.good_type,
                }
                // console.log(payData)
            } else {
                // 普7升级 返 true
                // const canUpdate = click_flag === 'update' && this.state.phoneType !== 'ios' && this.props.userInfo.vipInfo.vip_stat == 1
                const useActPrice = this.isInActivity(); // 有活动 且 不属于普7升级
                const androidInfo = this.props.userInfo.vipInfo.year[1]
                payData = {
                    book_id: androidInfo.vip_type,
                    pay_good_id: androidInfo.goodId,
                    p_name: androidInfo.vip_name,
                    // 是否活动价付
                    p_price: useActPrice ? androidInfo.activity_price : androidInfo.price,
                    p_desc: androidInfo.vip_detail,
                    type: androidInfo.vip_during_day,
                    bound: 0,
                    good_type: androidInfo.good_type,
                    pay_type:0
                }
            }
            let that = this;
            SDK.toPay(payData,function () {
                //  ios 且 没有微信 没弹窗
                // if(!that.props.userInfo.userInfo.installWechat && that.props.userInfo.phoneType === 'ios') {
                //     window.location.reload();
                // }
                if(that.props.userInfo.phoneType === 'ios') {
                    window.location.reload();
                } else {
                    that.props.userInfo.getVipStat();
                }
                // that.props.weChat.changeWeChatShow(true);
            })
        }
    }
    componentWillMount() {
        this.setState(() => {
            return { phoneType:this.props.userInfo.phoneType }
        })
        let end = new Date('2020-12-02').setHours(0);
            // end = Date.parse(new Date('2020-12-02 00:00:00'));
        this.countdown(end);
    }
    componentDidMount() {
        if(environment.environment !== 'wx' && isIPhoneX()) {
            // 86px
            document.getElementById('saleContent').style.marginTop = '-86px';
          } else if (environment.environment === 'wx') {
            document.getElementById('saleContent').style.marginTop = '0rem';
        } else {
            // 2.1rem;
            document.getElementById('saleContent').style.marginTop = '-2.1rem';
        }
    }
    render() {
        return (
            <Fragment>
                <div id='saleContent'>
                    <div className={styles.blockArea}>
                        <img src={require('./images/1-min.jpg')} alt=''/>
                    </div>
                    <div className={styles.blockArea}>
                        <img src={require('./images/2-min.jpg')} alt=''/>
                    </div>
                    <div className={`${styles.blockArea} ${styles.scrollBorder}`}>
                        <img src={require('./images/3-min.jpg')} alt=''/>
                        <div className={`${styles.scrollX} ${styles.base}`}>
                            <img src={require('./images/base.png')} alt='' />
                        </div>
                        <div className={`${styles.scrollX} ${styles.ability}`}>
                            <img src={require('./images/ability.png')} alt='' />
                        </div>
                        <div className={`${styles.scrollX} ${styles.class}`}>
                            <img src={require('./images/class.png')} alt='' />
                        </div>
                    </div>
                    <div className={styles.blockArea}>
                        <img src={require('./images/4-min.jpg')} alt=''/>
                    </div>
                    <div className={styles.blockArea}>
                        <img src={require('./images/5-min.jpg')} alt=''/>
                    </div>
                    <div className={styles.blockArea}>
                        <img src={require('./images/6-min.jpg')} alt=''/>
                    </div>
                    <div className={styles.blockArea}>
                        <img src={require('./images/7-min.jpg')} alt=''/>
                    </div>
                    <div className={`${styles.blockArea} ${styles.bottomArea} ${styles.countdown}`}>
                        {/* <img src={require('./images/8-min.jpg')} alt=''/> */}
                        <div className={styles.content}>
                            活动倒计时：<b>{this.state.day}</b><i>天</i><b>{this.state.hour}</b><i>小时</i><b>{this.state.min}</b><i>分钟</i><b>{this.state.sec}</b><i>秒</i>
                        </div>
                    </div>
                    <div className={`${styles.blockArea} ${styles.payBar}`}>
                        {/* <div className={styles.argument}>
                            <div className={styles.checkboxBorder}>
                                <label>
                                    <input
                                    onChange={this.handleChange}
                                    className={styles.checkbox} type='checkbox'/>
                                </label>
                            </div>
                            <div className={styles.word}>
                                我已阅读并同意<i onClick={this.handleJump.bind(this,'member')}>《会员服务协议》</i>和<i onClick={this.handleJump.bind(this,'auto')}>《隐私协议》</i>
                            </div>
                        </div> */}
                        <img src={require('./images/9-min.jpg')} alt=''/>
                        <div onClick={this.handleClickPay} className={styles.payIt}></div>
                    </div>
                </div>
                {
                    this.infoComponent()
                }
            </Fragment>
        )
    }
}
export default Pagesale;